<template>
  <div class="formulate-input-link--container">
    <div data-classification="box" data-type="checkbox" class="formulate-input">
      <div class="formulate-input-wrapper">
        <div @click="handleClick" data-type="checkbox" class="formulate-input-element formulate-input-element--checkbox">
          <input type="checkbox" v-model="context.model" v-bind="context.attributes" :value="context.model" />
          <label class="formulate-input-element-decorator"></label>
        </div>
        <label @click="handleClick" class="formulate-input-label formulate-input-label--after">
          {{ label }}
          <a v-if="link" :href="link.href" class="formulate-input-link" target="_blank"> {{ link.text }}</a>
          <span v-if="requiredAsterisk">*</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  computed: {
    value() {
      return this.context.model;
    },
    label() {
      return this.context.slotProps.component.settings.label;
    },
    link() {
      return this.context.slotProps.component.settings.link || '';
    },
    requiredAsterisk() {
      return this.context.slotProps.component.settings.required || false;
    },
  },
  methods: {
    handleClick(e) {
      this.context.model = !this.context.model;
    },
  },
};
</script>
